<script lang="ts">
    import cn from 'classnames';

    import { Signup } from '@components/layout/auth/signup';
    import { MainWrapper } from '@components/layout/main-wrapper';
    import { globalStore } from '@components/stores';
    import { LL } from '@i18n/i18n-svelte';
    import { APP_NAME } from '@shared/constants';
    import { SignupContext } from '@shared/types';

    import s from './page.module.css';
</script>

<svelte:head>
    <title>{$LL.auth.signupMeta.title({ appName: APP_NAME })}</title>
    <meta name="description" content={$LL.auth.signupMeta.desc({ appName: APP_NAME })} />
</svelte:head>

<MainWrapper isTransparent>
    <div class={cn(s.dialogWrapper, { [s.desktop]: $globalStore.isDesktopSite })}>
        <Signup
            isPage
            dialogClasses={s.dialog}
            descClasses={s.desc}
            place={SignupContext.Page}
        />
    </div>
</MainWrapper>
